import * as React from 'react';

import { TopReviewSnippetModel } from 'src/common/models/hotel/review-types';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';

export interface ReviewOnTopProps {
  topReviewSnippet?: TopReviewSnippetModel;
}

export const ReviewOnTop: React.FunctionComponent<ReviewOnTopProps> = props => {
  const { topReviewSnippet } = props;

  if (!topReviewSnippet) {
    return null;
  }

  const limitPhrase = (review: string): string => {
    if (review.length > 80) {
      return `"${review.slice(0, 80)}..."`;
    } else {
      return `"${review}"`;
    }
  };

  return (
    <div className="all-t-padding-two all-b-padding-four">
      <UitkLayoutFlex space="two">
        <>
          <UitkLayoutFlexItem>
            <UitkIcon name="sentiment_4" size={UitkIconSize.SMALL} />
          </UitkLayoutFlexItem>

          <UitkLayoutFlexItem>
            <UitkText>
              <span data-stid="top-review-text">{limitPhrase(topReviewSnippet.text)}</span>
            </UitkText>
          </UitkLayoutFlexItem>
        </>
      </UitkLayoutFlex>
    </div>
  );
};

ReviewOnTop.displayName = 'ReviewOnTop';
